import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { DisciplinaService } from '../../services/disciplina-service';
import { Disciplina } from '../../models/disciplina';
import { ToastrService } from 'ngx-toastr';
import { Curso } from '../../models/curso';
import { CursoService } from '../../services/curso-service';

@Component({
  selector: 'app-disciplina',
  templateUrl: './disciplina.component.html',
  styleUrls: ['./disciplina.component.scss']
})
export class DisciplinaComponent implements OnInit {

  insertForm: FormGroup;

  cursos: Curso[] = [];
  constructor(public fb: FormBuilder, public disciplinaService: DisciplinaService,
    private toastr: ToastrService, public cursoService: CursoService) {
    this.insertForm = fb.group({
      name: [null, [Validators.required]],
      curso: [-1],
    });

    this.cursoService.getSnapshot().then(c => {
      c.forEach(res => {
        let curso = new Curso();
        curso = res.val();
        curso.id = res.key;
        this.cursos.push(curso);
      });
    });

  }

  ngOnInit() {
  }

  save() {
    const name = this.insertForm.controls['name'].value;
    const curso = this.insertForm.controls['curso'].value;
    if (!name || name.toString().trim().length === 0) {
      this.toastr.error('Informe o nome da disciplina.');
      return;
    }
    if (!curso || curso === '-1' || curso === -1) {
      this.toastr.error('Você deve informar o curso dessa disciplina');
      return;
    }
    const disciplina = new Disciplina();
    disciplina.name = name;
    disciplina.curso = curso;
    this.disciplinaService.insert(disciplina).then((res) => {
      if (!res) {
        this.toastr.error('Erro ao cadastrar a disciplina');
      } else {
        this.toastr.success('Disciplina cadastrada');
      }
    });
    this.insertForm.patchValue({name: null,
      curso: -1});
  }
}
